import { event } from '@/api'
import {
	AGENDA_EVENT_GET,
	ATTENDEES_EVENT_GET,
	EVENT_GET,
	EVENT_GET_ERROR,
	EVENT_LOADING_STATUS,
	EVENTS_FETCH,
	EVENTS_FETCH_ERROR,
	PARTNERS_EVENT_GET,
	EVENTS_FETCH_CATEGORIES,
	EVENTS_FETCH_CATEGORIES_ERROR,
	REMOVE_ATTENDEES_EVENT,
	ATTENDEE_EVENT_GET,
	ATTENDEES_EVENT_CLEAR,
	SESSION_EVENT_GET,
	SESSION_EVENT_CLEAR,
	SESSION_EVENT_QUESTIONS_GET,
	SESSION_EVENT_QUESTION_UPDATE,
	SESSION_EVENT_QUESTIONS_CLEAR,
	EVENTS_CLEAR,
	EVENT_LOADING_CATEGORIES_STATUS,
	EVENT_GET_TRACKS,
	EVENT_TRACKS_LOADING_STATUS,
	EVENT_CLEAR_TRACKS,
	GET_ACTION_FILES,
	GET_ACTION_LINKS,
	EVENT_MY_AGENDA_LOADING_STATUS,
	EVENT_AGENDA_UPDATE_ITEM,
	EVENT_POLLS_LOADING_STATUS,
	UPDATE_EVENT_POLLS,
	EVENT_RATINGS_LOADING_STATUS,
	UPDATE_EVENT_RATINGS,
	UPDATE_SESSION_RATINGS,
	EVENT_SPEAKERS_GET,
	EVENT_SPEAKERS_CLEAR,
	EVENT_GET_EXHIBITOR,
	GET_BOOT_STAFF_LIST,
	BOOT_STAFF_LOADING_STATUS,
	DELETE_FOLLOW_NOTE,
	SET_FOLLOW_STATUS,
	SET_FOLLOW_NOTE,
	POST_EVENT_SESSIONS_REGISTER,
	POST_EVENT_SESSIONS_REGISTER_LOADING,
	DELETE_EVENTS_SESSIONS_REGISTER,
	EVENT_GET_EXHIBITOR_ERROR,
	EVENT_CLEAR_EXHIBITOR,
} from '@/store/event/types'

const deleteRegisterSessions = async (ctx, id, deleteRegister) => {
	ctx.commit(POST_EVENT_SESSIONS_REGISTER_LOADING, true)
	try {
		const { data } = await event.deleteRegisterEventSession(id, deleteRegister)
		ctx.commit(DELETE_EVENTS_SESSIONS_REGISTER, data)
		ctx.commit(POST_EVENT_SESSIONS_REGISTER_LOADING, false)
	} catch (e) {
		ctx.commit(POST_EVENT_SESSIONS_REGISTER_LOADING, false)
		console.log(e)
		throw e
	}
}

const postRegisterSession = async (ctx, sessionRegister) => {
	ctx.commit(POST_EVENT_SESSIONS_REGISTER_LOADING, true)
	try {
		const { data } = await event.postRegisterEventSession(sessionRegister)
		ctx.commit(POST_EVENT_SESSIONS_REGISTER, data)
		ctx.commit(POST_EVENT_SESSIONS_REGISTER_LOADING, false)
	} catch (e) {
		ctx.commit(POST_EVENT_SESSIONS_REGISTER_LOADING, false)
		console.log(e)
		throw e
	}
}

const getBoothStaff = async (ctx, query = '') => {
	ctx.commit(BOOT_STAFF_LOADING_STATUS, true)
	try {
		const { data, headers } = await event.getBoothStaffList(query)
		const pageCount = headers['x-pagination-page-count']
		const totalCount = headers['x-pagination-total-count']
		const response = { data, pageCount, totalCount }

		ctx.commit(GET_BOOT_STAFF_LIST, response)
		ctx.commit(BOOT_STAFF_LOADING_STATUS, false)
	} catch (e) {
		console.error(e)
	}
}

const followExhibitor = async ({ commit }, { id, follow_status }) => {
	try {
		const { data } = await event.putExhibitorPartnersFollow(id, { follow_status })
		commit(SET_FOLLOW_STATUS, data)
	} catch (e) {
		console.log(e)
		throw e
	}
}
const saveFollowNote = async ({ commit }, { id, follow_note }) => {
	try {
		const { data } = await event.putExhibitorPartnersFollow(id, { follow_note })
		commit(SET_FOLLOW_NOTE, data)
	} catch (e) {
		console.log(e)
		throw e
	}
}
const deleteFollowNote = async ({ commit }, { id, follow_note }) => {
	try {
		const { data } = await event.deleteExhibitorPartnersFollow(id, { follow_note })
		commit(DELETE_FOLLOW_NOTE, data)
	} catch (e) {
		console.log(e)
		throw e
	}
}

const fetchEvents = async (ctx, filters) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		const { data, headers } = await event.fetchEvents(filters)
		const pageCount = headers['x-pagination-page-count']
		const response = { data, pageCount }
		ctx.commit(EVENTS_FETCH, response)
		ctx.commit(EVENT_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(EVENTS_FETCH_ERROR, e)
		console.error(e)
	}
}

const fetchEventCategories = async (ctx, query) => {
	ctx.commit(EVENT_LOADING_CATEGORIES_STATUS, true)
	try {
		const { data, headers } = await event.fetchEventCategories(query)
		const pageCount = headers['x-pagination-page-count']
		const perPage = headers['x-pagination-per-page']
		const totalCount = headers['x-pagination-total-count']
		const currentPage = headers['x-pagination-current-page']

		const response = {
			data,
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}

		ctx.commit(EVENTS_FETCH_CATEGORIES, response)
		ctx.commit(EVENT_LOADING_CATEGORIES_STATUS, false)
	} catch (e) {
		ctx.commit(EVENTS_FETCH_CATEGORIES_ERROR, e)
		console.error(e)
	}
}

const getEvent = async (ctx, eventId) => {
	ctx.commit(EVENT_LOADING_STATUS, true)

	try {
		const query = {
			expand: 'polls,is_attendees_available,is_agenda_available,speakersList,partner_groups,eventActions,ratings,event_map_url',
		}

		const { data } = await event.getEvent(eventId, query)

		ctx.commit(EVENT_GET, data)
		ctx.commit(EVENT_LOADING_STATUS, false)
		ctx.commit(ATTENDEES_EVENT_CLEAR)
		if (data.is_attendees_available) {
			ctx.dispatch('getAttendeesEvent', `?event_id=${eventId}&filter=event`)
		}
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	} finally {
		ctx.commit(EVENT_LOADING_STATUS, false)
	}
}

const getAgendaEvent = async (ctx, query) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		const { data, headers } = await event.getAgendaEvent(query)
		const pageCount = headers['x-pagination-page-count']
		const response = { data, pageCount }

		ctx.commit(AGENDA_EVENT_GET, response)
		ctx.commit(EVENT_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

const getAttendeesEvent = async (ctx, query = '') => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		const { data, headers } = await event.getAttendeesEvent(query)

		const pageCount = headers['x-pagination-page-count']
		const totalCount = headers['x-pagination-total-count']
		const response = { data, pageCount, totalCount }

		ctx.commit(ATTENDEES_EVENT_GET, response)
		ctx.commit(EVENT_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

const getAttendee = async (ctx, id) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		const { data } = await event.getAttendeeEvent(id)
		ctx.commit(ATTENDEE_EVENT_GET, data)

		ctx.commit(EVENT_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

const getSession = async (ctx, id) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		const { data } = await event.getEventSession(id)

		ctx.commit(SESSION_EVENT_GET, data)
		ctx.commit(EVENT_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

const clearSession = async (ctx) => {
	try {
		ctx.commit(SESSION_EVENT_CLEAR)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

const getActionFiles = async (ctx, query) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		const { data, headers } = await event.getActionFiles(query)
		const pageCount = headers['x-pagination-page-count']
		const perPage = headers['x-pagination-per-page']
		const totalCount = headers['x-pagination-total-count']
		const currentPage = headers['x-pagination-current-page']

		const response = {
			data,
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}

		ctx.commit(GET_ACTION_FILES, response)
		ctx.commit(EVENT_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

const getActionLinks = async (ctx, query) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		const { data, headers } = await event.getActionLinks(query)

		const pageCount = headers['x-pagination-page-count']
		const perPage = headers['x-pagination-per-page']
		const totalCount = headers['x-pagination-total-count']
		const currentPage = headers['x-pagination-current-page']

		const response = {
			data,
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}

		ctx.commit(GET_ACTION_LINKS, response)
		ctx.commit(EVENT_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

const fetchPartners = async (ctx, filters) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		const { data, headers } = await event.fetchPartners(filters)
		const pageCount = headers['x-pagination-page-count']
		const response = { data, pageCount }
		ctx.commit(PARTNERS_EVENT_GET, response)
		ctx.commit(EVENT_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(EVENTS_FETCH_ERROR, e)
		console.error(e)
	}
}

const clearAttendeesEvent = (ctx) => {
	ctx.commit(REMOVE_ATTENDEES_EVENT)
}

const addSessionQuestion = async (ctx, payload) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		await event.addSessionAgendaQuestion(payload)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	} finally {
		ctx.commit(EVENT_LOADING_STATUS, false)
	}
}

const getSessionQuestions = async (ctx, payload) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		if (payload.page) {
			ctx.commit(SESSION_EVENT_QUESTIONS_CLEAR)
		}
		if (!payload.session) {
			const { data } = await event.getEventSession(payload.sessionId)
			ctx.commit(SESSION_EVENT_GET, data)
		}
		const { data, headers } = await event.getSessionQuestions({
			sessionId: payload.sessionId,
			page: payload.page || 1,
		})
		const pageCount = headers['x-pagination-page-count']
		const perPage = headers['x-pagination-per-page']
		const totalCount = headers['x-pagination-total-count']
		const currentPage = headers['x-pagination-current-page']
		const response = {
			data,
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}
		ctx.commit(SESSION_EVENT_QUESTIONS_GET, response)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	} finally {
		ctx.commit(EVENT_LOADING_STATUS, false)
	}
}

const upvoteSessionQuestion = async (ctx, answerId) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		const { data } = await event.upvoteSessionQuestion(answerId)
		ctx.commit(SESSION_EVENT_QUESTION_UPDATE, {
			answerId: data.session_question_answer_id,
			status: 1,
		})
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	} finally {
		ctx.commit(EVENT_LOADING_STATUS, false)
	}
}

const deleteUpvoteSessionQuestion = async (ctx, answerId) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		const { data } = await event.deleteUpvoteSessionQuestion(answerId)
		ctx.commit(SESSION_EVENT_QUESTION_UPDATE, {
			answerId: data.session_question_answer_id,
			status: 0,
		})
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	} finally {
		ctx.commit(EVENT_LOADING_STATUS, false)
	}
}

const clearEventCategories = async (ctx) => {
	try {
		ctx.commit(EVENTS_CLEAR)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

const addEventToSchedule = async (ctx, data) => {
	try {
		await event.addToSchedule(data)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

const removeEventFromSchedule = async (ctx, id) => {
	try {
		await event.removeFromSchedule(id)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

const getEventTracks = async (ctx, eventId) => {
	ctx.commit(EVENT_TRACKS_LOADING_STATUS, true)
	try {
		const { data, headers } = await event.getEventTracks(eventId)
		const pageCount = headers['x-pagination-page-count']
		const perPage = headers['x-pagination-per-page']
		const totalCount = headers['x-pagination-total-count']
		const currentPage = headers['x-pagination-current-page']
		const response = {
			data,
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}
		ctx.commit(EVENT_GET_TRACKS, response)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	} finally {
		ctx.commit(EVENT_TRACKS_LOADING_STATUS, false)
	}
}

const clearEventTracks = async (ctx) => {
	try {
		ctx.commit(EVENT_CLEAR_TRACKS)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

const addMyAgenda = async (ctx, { id, single }) => {
	try {
		ctx.commit(EVENT_MY_AGENDA_LOADING_STATUS, { value: true, id })
		const { data } = await event.addMyAgenda({ agenda_id: id })
		if (single) {
			ctx.commit(SESSION_EVENT_GET, { ...ctx.state.session, is_scheduled: true })
		} else {
			ctx.commit(EVENT_AGENDA_UPDATE_ITEM, { agenda: data.eventsAgenda, id, remove: false })
		}
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	} finally {
		ctx.commit(EVENT_MY_AGENDA_LOADING_STATUS, { value: false })
	}
}

const removeMyAgenda = async (ctx, { id, myAgenda, single, filter }) => {
	try {
		ctx.commit(EVENT_MY_AGENDA_LOADING_STATUS, { value: true, id })
		const { data } = await event.removeMyAgenda(id)
		if (single) {
			ctx.commit(SESSION_EVENT_GET, { ...ctx.state.session, is_scheduled: false })
		} else {
			ctx.commit(EVENT_AGENDA_UPDATE_ITEM, {
				agenda: data.eventsAgenda,
				id,
				remove: myAgenda,
				filter,
			})
		}
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	} finally {
		ctx.commit(EVENT_MY_AGENDA_LOADING_STATUS, { value: false })
	}
}

const voteEventPolls = async (ctx, { answers, eventId, sessionId }) => {
	try {
		ctx.commit(EVENT_POLLS_LOADING_STATUS, true)
		for (const [index, answer] of answers.entries()) {
			const pollAnswer = { poll_id: answer.poll_id }
			if (answer.poll_answer_id && answer.poll_answer_id.length) {
				pollAnswer.poll_answer_id = answer.poll_answer_id
			}
			if (answer.custom_answer && answer.custom_answer.length) {
				pollAnswer.custom_answer = answer.custom_answer
			}
			await event.voteEventPoll(pollAnswer)
			if (index + 1 === answers.length) {
				if (eventId) {
					const query = {
						expand: 'polls,is_attendees_available,is_agenda_available,speakersList,partner_groups,eventActions',
					}
					const { data } = await event.getEvent(eventId, query)
					ctx.commit(UPDATE_EVENT_POLLS, data.polls)
				} else if (sessionId) {
					const { data } = await event.getEventSession(sessionId)
					ctx.commit(SESSION_EVENT_GET, data)
				}
			}
		}
	} catch (e) {
		console.log(e)
	} finally {
		ctx.commit(EVENT_POLLS_LOADING_STATUS, false)
	}
}

const getEventSpeakersById = async (ctx, query) => {
	try {
		ctx.commit(EVENT_LOADING_STATUS, true)
		const { data, headers } = await event.getEventSpeakersById(query)
		const pageCount = headers['x-pagination-page-count']
		const perPage = headers['x-pagination-per-page']
		const totalCount = headers['x-pagination-total-count']
		const currentPage = headers['x-pagination-current-page']
		const response = {
			data,
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}
		ctx.commit(EVENT_SPEAKERS_GET, response)
	} catch (e) {
		console.log(e)
	} finally {
		ctx.commit(EVENT_LOADING_STATUS, false)
	}
}

const clearEventSpeakers = async (ctx) => {
	try {
		ctx.commit(EVENT_SPEAKERS_CLEAR)
	} catch (e) {
		console.log(e)
	}
}

const voteEventRatings = async (ctx, { ratings, eventId }) => {
	try {
		ctx.commit(EVENT_RATINGS_LOADING_STATUS, true)
		for (const [index, rating] of ratings.entries()) {
			await event.voteEventRating({ ...rating, event_id: eventId })
			if (index + 1 === ratings.length) {
				const query = {
					expand: 'polls,is_attendees_available,is_agenda_available,speakersList,partner_groups,eventActions,ratings',
				}
				const { data } = await event.getEvent(eventId, query)
				ctx.commit(UPDATE_EVENT_RATINGS, data.ratings)
			}
		}
	} catch (e) {
		console.log(e)
	} finally {
		ctx.commit(EVENT_RATINGS_LOADING_STATUS, false)
	}
}

const voteSessionRatings = async (ctx, { ratings, sessionId }) => {
	try {
		ctx.commit(EVENT_RATINGS_LOADING_STATUS, true)
		for (const [index, rating] of ratings.entries()) {
			await event.voteSessionRating({ ...rating, agenda_id: sessionId })
			if (index + 1 === ratings.length) {
				const { data } = await event.getEventSession(sessionId)
				ctx.commit(UPDATE_SESSION_RATINGS, data.ratings)
			}
		}
	} catch (e) {
		console.log(e)
	} finally {
		ctx.commit(EVENT_RATINGS_LOADING_STATUS, false)
	}
}

const getExhibitorById = async (ctx, { id, groupId }) => {
	try {
		ctx.commit(EVENT_LOADING_STATUS, true)
		const { data } = await event.getExhibitorById(id, groupId)
		ctx.commit(EVENT_GET_EXHIBITOR, data)
	} catch (e) {
		ctx.commit(EVENT_GET_EXHIBITOR_ERROR, e)
		console.log(e)
	} finally {
		ctx.commit(EVENT_LOADING_STATUS, false)
	}
}

const clearExhibitor = async (ctx) => {
	try {
		ctx.commit(EVENT_CLEAR_EXHIBITOR)
	} catch (e) {
		console.log(e)
	}
}

export default {
	getEvent,
	getAgendaEvent,
	fetchEvents,
	fetchPartners,
	getAttendeesEvent,
	fetchEventCategories,
	clearAttendeesEvent,
	getAttendee,
	getSession,
	clearSession,
	getActionFiles,
	getActionLinks,
	addSessionQuestion,
	getSessionQuestions,
	upvoteSessionQuestion,
	deleteUpvoteSessionQuestion,
	clearEventCategories,
	addEventToSchedule,
	removeEventFromSchedule,
	getEventTracks,
	clearEventTracks,
	addMyAgenda,
	removeMyAgenda,
	voteEventPolls,
	getEventSpeakersById,
	clearEventSpeakers,
	voteEventRatings,
	voteSessionRatings,
	getExhibitorById,
	followExhibitor,
	saveFollowNote,
	getBoothStaff,
	deleteFollowNote,
	postRegisterSession,
	deleteRegisterSessions,
	clearExhibitor,
}
